export default __webpack_public_path__ + "static/media/easyCreateIcon.c634e867.png";